import React from 'react';
import {
  CardStyleInterpolators,
  createStackNavigator,
} from '@react-navigation/stack';

import {makeId} from '../../utils';
import {E_NAVIGATION_DESTINATIONS} from '../../@types';
import {CreateWorkOrder, WorkOrders, WorkOrderDetails} from './screens';

const Stack = createStackNavigator();

const WorkOrdersNavigator = props => {
  const options = {
    headerShown: false,
    cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
  };

  return (
    <Stack.Navigator
      initialRouteName={E_NAVIGATION_DESTINATIONS.WORK_ORDERS_LIST}>
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.WORK_ORDERS_LIST}
        component={WorkOrders}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.CREATE_WORK_ORDER}
        component={CreateWorkOrder}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.WORK_ORDER_EDIT}
        component={CreateWorkOrder}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
      <Stack.Screen
        name={E_NAVIGATION_DESTINATIONS.WORK_ORDER_DETAILS}
        component={WorkOrderDetails}
        options={{...options, animationTypeForReplace: 'pop'}}
        key={makeId(12)}
      />
    </Stack.Navigator>
  );
};

export const workOrderScreens = {
  [E_NAVIGATION_DESTINATIONS.WORK_ORDERS_LIST]: '/workOrdersList',
  [E_NAVIGATION_DESTINATIONS.CREATE_WORK_ORDER]: '/addWorkOrder',
  [E_NAVIGATION_DESTINATIONS.WORK_ORDER_EDIT]: '/workOrderEdit',
  [E_NAVIGATION_DESTINATIONS.WORK_ORDER_DETAILS]: '/WorkOrderDetails',
};

export default WorkOrdersNavigator;
